import { ContactForm } from 'ui/components/public/patterns/ContactForm/ContactForm';

/**
 * 問い合わせ
 */
export const Contact: React.FC = () => {
    return <ContactForm />;
};
